import { useTheme, useMediaQuery } from "@mui/material";
import SmallScreenProduct from "./small";
import LargeScreenProduct from "./large";
import { CartItemProps } from "../../models/product";

const CartItem = (props: CartItemProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return isSmallScreen ? ( 
    <SmallScreenProduct {...props}/> 
  ) : (
    <LargeScreenProduct {...props}/>
  );
};

export default CartItem;
